export default __webpack_public_path__ + "static/media/channel4.dd4e2f71.svg";